import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  
  
    imageContainer: {
        width: '100%',
        height: 'fit-content',
        margin: '2% auto',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backdropFilter: 'blur(10px)',
        zIndex: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end'
    },
    // img: {
    //     margin: '0 auto',
    //     height: 'auto',
    //     width: 500,
    //     [theme.breakpoints.down('768')]: {
    //         width: 200
    //     },
    // },
    title: {
        fontSize: 30,
        color: '#344450',
        fontWeight: 'bold',
        marginBottom: '1%',
        [theme.breakpoints.down('1100')]: {
            fontSize: 22,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 20,
        },
        width: '100%',
        textAlign: 'center'
    },
    interactionsSummary: {
        color: '#344450',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        alignContent: 'center',
        width: '30%',
        [theme.breakpoints.down('1100')]: {
            width: '40%',
        },
        [theme.breakpoints.down('769')]: {
            width: '100%',
        },
    },
    interactionsCount: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: 'fit-content',
    },
    interactionsText: {
        fontSize: 18,
        marginRight: 3,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
        }
    },
    interactionsIcon: {
        fontSize: 24,
        marginRight: 5,
        [theme.breakpoints.down('1100')]: {
            fontSize: 18,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 16,
        }
    },
    trainingInfosContainer: {
        margin: '4% 0',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        color: '#344450',
        backgroundColor: '#E4E4E4',
    },
    tabledesign: {
        borderCollapse: 'collapse',
        margin: '1% auto',
        width: '90%',
    },
    trainingInfo: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        margin: '0 auto',
        marginTop: '3%'
    },
    trainingRow: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderBottom: 'none'
    },
    trainingInfoL: {
        borderRight: '5px solid #F5B750',
        // paddingRight: '5%',
        fontSize: 18,
        fontWeight: 'bold',
        width: '20%',
        borderBottom: 'none',
        [theme.breakpoints.down('769')]: {
            borderRight: '3px solid #F5B750',
            fontSize: 16,
            width: '50%',
        }
    },
    trainingInfoLAR: {
        borderLeft: '5px solid #F5B750',
        paddingLeft: '5%',
        fontSize: 18,
        fontWeight: 'bold',
        width: '20%',
        borderBottom: 'none',
        [theme.breakpoints.down('769')]: {
            borderLeft: '3px solid #F5B750',
            fontSize: 16,
            width: '50%',
        }
    },
    trainingInfoV: {
        width: '50%',
        borderBottom: 'none',
        fontSize: 18,
        // paddingLeft: '5%',
        [theme.breakpoints.down('769')]: {
            width: '50%',
            fontSize: 16,
        }
    },
    trainingInfoLabel: {
        fontWeight: 'bold',
        marginBottom: 5,
        fontSize: 20,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
        }
    },
    trainingInfoValue: {
        paddingLeft: '3%',
        marginBottom: 8,
        fontSize: 18,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
            marginBottom: 5,
        }
    },
    descriptionContainer: {
        width: '90%',
        margin: '0 auto',
        marginTop: '3%',
        textAlign: 'center'
    },
    description: {
        fontSize: 20,
        textAlign: 'left',
        [theme.breakpoints.down('1100')]: {
            fontSize: 18,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 16,
        },
    },
    registerButtonContainer: {
        padding: '0.5% 6%',
        margin: '2% auto',
        borderRadius: 5,
        cursor: 'pointer',
        backgroundColor: '#344450',
        color: '#FFFFFF',
        border: '3px solid #344450',
        '&:hover': {
            color: '#FFFFFF',
            backgroundColor: '#F5B750',
            border: '3px solid #F5B750',
        }
    },
    registerButton: {
        fontSize: 18,
        fontWeight: 'bold',
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
        },
    },
    alreadyRegistered: {
        color: '#F5B750',
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center'
    }
}))

export default useStyles